const craftsmenAltTextI18nEn = {
    'altTextTeamsImage': 'Repair Rebels craftsmen network - team collaboration',
    'altTextExpertiseImage': 'Germany\'s best tailors and shoemakers',
    'altTextDecorateImage': 'Top craftspeople for sustainable fashion repairs',
  };
  
export default craftsmenAltTextI18nEn;